import { dataPhoneCode } from 'components/helper/countryPhoneCode';
import React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import FormHelperText from '@mui/joy/FormHelperText';

interface Props {
  id?: string;
  label?: string;
  name?: string;
  values?: any;
  onChange?: (e?: any) => void;
  isValid?: boolean;
  feedback?: any;
  placeholder?: string;
  className?: string;
  logo?: string;
  isMissing?: any;
  disabled?: boolean;
  setLabelHight?: boolean;
}

const SelectPhoneCodeInput = (props: Props) => {
  return (
    <FormControl
      id={props.id}
      disabled={props.disabled}
      error={!!props.isMissing}
    >
      <div
        style={
          props.setLabelHight
            ? {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                minHeight: '40px',
              }
            : { marginBottom: '2px' }
        }
      >
        <FormLabel
          className={`select-label label-14px`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            margin: props.setLabelHight ? 0 : undefined,
            marginBottom: '1px !important',
            backgroundColor: props.isMissing ? '#FFEBEB' : '',
          }}
        >
          <span>{props.label}</span>
          {(props?.logo && props.setLabelHight) && (
            <FormLabel className={`csu-logo-select-input-float-right ${props?.logo ?? ''}`.trim()} />
          )}
        </FormLabel>
        {(props?.logo && !props.setLabelHight) ? <span className={`cm-logo-select-input-float-right ${props?.logo ?? null}`}></span> : null}
      </div>
      <Select
        onChange={(e, newValue) => {
          if (props.onChange) {
            props.onChange({
              target: {
                name: props.name,
                value: newValue,
              },
            });
          }
        }}
        name={props.name}
        value={props.values ?? '+1'}
        placeholder={props.placeholder}
        disabled={props.disabled}
        variant="outlined"
        size="md"
        sx={{
          backgroundColor: '#fff',
          borderRadius: '0.5rem',
          height: '50px',
          minHeight: '50px',
          fontSize: '16px',
          fontWeight: 400,
          paddingLeft: '14px',
          paddingRight: '14px',
          boxSizing: 'border-box',
          lineHeight: '1.5',
          '& .MuiSelect-button': {
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            minHeight: 'unset',
            lineHeight: '1.5',
          },
        }}
      >
        {dataPhoneCode.map((item, index) => (
          <Option key={index} value={item.dial_code}>
            {item.name} ({item.dial_code})
          </Option>
        ))}
      </Select>
      {props.feedback && (
        <FormHelperText>{props.feedback}</FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectPhoneCodeInput;
